import { format } from 'date-fns';
import type { CreditMemo } from '@/types/creditMemo';

export function formatCreditMemoMoney(amount: number | null | undefined, currency = 'USD') {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).format(Number(amount ?? 0));
}

export function formatCreditMemoLabel(value: string | null | undefined) {
  if (!value) return '-';
  return value
    .split('_')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');
}

export function formatCreditMemoDate(value: string | null | undefined) {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return format(date, 'PP');
}

export function formatCreditMemoShortDate(value: string | null | undefined) {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return format(date, 'MMM d, yyyy');
}

export function getCreditMemoCustomerName(memo: CreditMemo) {
  return memo.customer?.displayName || 'Unknown customer';
}

export function getCreditMemoInvoiceLabel(memo: CreditMemo) {
  return memo.invoiceId || '-';
}

export function getCreditMemoQboLabel(memo: CreditMemo) {
  if (memo.qbCreditMemoId) return `CreditMemo ${memo.qbCreditMemoId}`;
  if (memo.qbRefundReceiptId) return `RefundReceipt ${memo.qbRefundReceiptId}`;
  return '-';
}
